<section class="section section--hero">
    <div id="banner" class="carousel slide h-auto banner-home" data-ride="carousel">
        <ol class="carousel-indicators">
            <li *ngFor="let item of banner" [ngClass]="(item.no==0)?'active':''" data-target="#banner"
                attr.data-slide-to="{{item.no}}"></li>
        </ol>
        <div class="carousel-inner h-auto">
            <div *ngFor="let item of banner" [ngClass]="(item.no==0)?'carousel-item active':'carousel-item'"
                data-interval="5000" data-ride="true" class="h-auto">
                <a (click)="clickEdit(item.banner_uri,item.banner_type,item.ref_id)">
                    <img *ngIf="flag == 'th'; else elsebanner_image" class="d-block w-100 h-auto"
                        src="{{ !isMobile ? item.banner_image : item.banner_image_mobile }}">
                    <ng-template #elsebanner_image>
                        <img class="d-block w-100 h-auto"
                            src="{{!isMobile ? item.banner_image_en : item.banner_image_mobile_en}}">
                    </ng-template>
                </a>
            </div>
        </div>
        <a class="carousel-control-prev" href="#banner" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#banner" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</section>

<section class="section section--feature -form" style="padding-bottom: 90px;">
    <div class="container">
        <div class="row">

            <ul class="list list-circle d-block d-sm-block d-md-block d-lg-none d-xl-none">
                <li class="col-xs-12 col-sm-6 col-md-3 list-two-row">
                    <a [routerLink]="['/invest-plan','beginer-investment']">
                        <span rel="border-circle">
                            <i class="icon icon-ipo"></i>
                        </span>
                        <span class="text">{{language.sub4menu1}}</span>
                    </a>
                </li>
                <li class="col-xs-12 col-sm-6 col-md-3 list-two-row">
                    <a [routerLink]="['/FundRecommend','option1']">
                        <span rel="border-circle">
                            <i class="icon icon-analytics"></i>
                        </span>
                        <span class="text">{{language.sub4menu2}}</span>
                    </a>
                </li>
                <li class="col-xs-12 col-sm-6 col-md-3 list-two-row">
                    <a [routerLink]="['/Promotion','non-promo']">
                        <span rel="border-circle">
                            <i class="icon icon-gifts "></i>
                        </span>
                        <span class="text">{{language.sub4menu3}}</span>
                    </a>
                </li>
                <li class="col-xs-12 col-sm-6 col-md-3 list-two-row">
                    <a [routerLink]="['/download-form']">
                        <span rel="border-circle">
                            <i class="icon icon-download"></i>
                        </span>
                        <span class="text">{{language.sub4menu4}}</span>
                    </a>
                </li>
            </ul>

            <div class="col-lg-8 col-md-6">
                <ul class="list list-circle d-none d-sm-none d-md-none d-lg-block d-xl-block">
                    <li class="col-xs-12 col-sm-6 col-md-3 list-two-row">
                        <a [routerLink]="['/calculate']">
                            <span rel="border-circle">
                                <i class="icon icon-ipo"></i>
                            </span>
                            <span class="text">{{language.sub4menu1}}</span>
                        </a>
                    </li>
                    <li class="col-xs-12 col-sm-6 col-md-3 list-two-row">
                        <a [routerLink]="['/FundRecommend','option1']">
                            <span rel="border-circle">
                                <i class="icon icon-analytics"></i>
                            </span>
                            <span class="text">{{language.sub4menu2}}</span>
                        </a>
                    </li>
                    <li class="col-xs-12 col-sm-6 col-md-3 list-two-row">
                        <a [routerLink]="['/Promotion','non-promo']">
                            <span rel="border-circle">
                                <i class="icon icon-gifts "></i>
                            </span>
                            <span class="text">{{language.sub4menu3}}</span>
                        </a>
                    </li>
                    <li class="col-xs-12 col-sm-6 col-md-3 list-two-row">
                        <a [routerLink]="['/download-form']">
                            <span rel="border-circle">
                                <i class="icon icon-download"></i>
                            </span>
                            <span class="text">{{language.sub4menu4}}</span>
                        </a>
                    </li>
                </ul>

                <div class="row">
                    <div class="col-md-12 col-lg-6 grid-display" rel="group-widget">
                        <section class="widget -cal">
                            <form action="" class="form -day">
                                <header>
                                    <h3 class="topic-title">
                                        <span rel="border-circle">
                                            <i class="icon icon-cal"></i>
                                        </span>
                                        <span class="text" *ngIf="flag == 'th'">{{language.twoboxtitle1}}</span>
                                        <span class="text" *ngIf="flag == 'en'"
                                            style="font-size: 24px;">{{language.twoboxtitle1}}</span>
                                    </h3>
                                    <p class="intro" data-mh="group-intro-widget" style="height: 80px;">
                                        {{language.twoboxdetail1}}</p>
                                </header>

                                <div class="form-group">
                                    <app-select [selectList]="selectListDropdown"
                                        defaultTitle="{{language.defaulttitle1}}" [isLight]="true"
                                        [isRequire]="invalidPerfInvest" [enableSearch]="true"
                                        (fundId)="getFundIdFromSelect($event)">
                                    </app-select>
                                </div>

                                <div class="form-group">
                                    <app-datepicker [defaultPlaceholder]="language.defaulttitledate1"
                                        (pickDate)="getPickDate($event)" #datepick1 (blur)="setDate1(datepick1.value)">
                                    </app-datepicker>
                                </div>

                                <footer class="text-align -xs">
                                    <app-button size="cal-lg" text="{{language.defaulttitlebtn}}"
                                        (click)="clickCalculate('เครื่องคำนวณการลงทุน')">
                                    </app-button>
                                </footer>
                            </form>
                        </section>
                    </div>

                    <div class="col-md-12 col-lg-6" rel="group-widget">
                        <section class="widget -cal ">
                            <form action="" class="form -day">
                                <header>
                                    <h3 class="topic-title">
                                        <span rel="border-circle">
                                            <i class="icon icon-barchart-fund"></i>
                                        </span>
                                        <span class="text" *ngIf="flag == 'th'">{{language.twoboxtitle2}}</span>
                                        <span class="text" *ngIf="flag == 'en'"
                                            style="font-size: 24px;">{{language.twoboxtitle2}}</span>
                                    </h3>
                                    <p class="intro" data-mh="group-intro-widget" style="height: 80px;">
                                        {{language.twoboxdetail2}}</p>
                                </header>
                                <div class="form-group">
                                    <app-select [selectList]="selectListDropdown"
                                        defaultTitle="{{language.defaulttitle1}}" [isLight]="true"
                                        [isRequire]="invalidFundPerf" [enableSearch]="true"
                                        (fundId)="getFundIdFromSelect2($event)">
                                    </app-select>
                                </div>
                                <div class="form-group">
                                    <app-datepicker class="selectiongroup2"
                                        [defaultPlaceholder]="language.defaulttitledate2"
                                        (pickDate)="getPickDate2($event)" #datepick2 (blur)="setDate2(datepick2.value)">
                                    </app-datepicker>
                                </div>
                                <footer class="text-align -xs">
                                    <app-button size="cal-lg" text="{{language.defaulttitlebtn}}"
                                        (click)="clickCalculate2('ผลการดำเนินงานกองทุน')">
                                    </app-button>
                                    <div id="btnPerformance-trigger" class="hidden" data-toggle="modal"
                                        data-target="#perforModal"></div>
                                </footer>
                            </form>
                        </section>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 ">
                <app-collapse-accordion [collapseIIV]="iivFund" [date]="displayDate" [time]="displayTime">
                </app-collapse-accordion>
            </div>
        </div>
    </div>
</section>

<section class="section section--investment curve -white -top" #scrollTo>
    <div class="container">
        <header class="header-section">
            <div class="row">
                <div class="col-sm-7 col-md-7 col-lg-6">
                    <h1 class="topic-title font-34">
                        <span rel="border-circle">
                            <i class="icon icon-profit"></i>
                        </span>
                        <span class="text middle">{{language.titlebox3}}</span>
                    </h1>
                </div>
                <div class="col-sm-5 col-md-5 col-lg-6 text-right -sm col-right-d-search" style="padding-top: 10px;">
                    <div class="input-group mb-3 input-group-button">
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-secondary btn-investment-search" type="button"
                                (click)="onSearch()" id="button-addon1">
                                <i class="fas fa-search"></i>
                            </button>
                        </div>
                        <input id="searchtxt" type="text" #searchFund (blur)="setValueSearch(searchFund.value)"
                            (keydown)="keyDownFunction($event,searchFund.value)"
                            class="form-control input-investment-search" placeholder="{{language.searchtitle3}}"
                            aria-label="Example text with button addon" aria-describedby="button-addon1" />
                    </div>
                </div>
            </div>
        </header>

        <div class="row">
            <div class="col-md-12">
                <app-collapse-card header={{language.subtitlebox3}}>
                    <app-swiper>
                        <div *ngFor="let item of sectionList; let sectionIndex = index" class="swiper-slide">
                            <app-icon-button [icon]="item.icon" [iconActive]="item.activeIcon"
                                [active]="checkAllAgain(sectionIndex)" [label]="item.title"
                                (click)="onSelectedContent(item.content,sectionIndex)"></app-icon-button>
                        </div>
                    </app-swiper>
                </app-collapse-card>
            </div>
        </div>

        <section class="section-follow">
            <p class="note">
                <span class="text">{{language.titlebox4}}</span>
                <span class="favicon" style="padding-left: 10px;">
                    <span rel="border-circle" style="position: absolute; display: inherit;
           width: 36px; height: 36px; background-color: white;
           border: 1px solid #FFAF3E; padding-top: 6px; font-size: 20px; text-align: center;">
                        <i class="far fa-heart" style="color:#FFAF3E;"></i>
                    </span>
                </span>
            </p>
        </section>

        <!-- <section class="grid-fund"> -->
        <app-fund-card [renderFundObject]="filterFundList"></app-fund-card>

        <div class="note">
            <p class="font-18 color-brand">
                <i class="fas fa-star" style="color:#ffac02"></i>
                <span class="text">{{language.labelpsbox4}}</span>
            </p>
        </div>
        <app-paginator [currentPage]="currentPage" [totalPage]="totalPageCount"
            (currentPageNumber)="setCurrentPage($event)"></app-paginator>
    </div>
</section>

<section class="section section--feature -report">
    <div class="container">

        <div class="row">
            <div class="col-md-12 offset-lg-4 col-lg-8 ">
                <section class="group-section">
                    <header class="text-center">
                        <h2 class="topic-title">
                            <span rel="border-circle">
                                <i class="fas fa-question" style="color: white; font-size: 20px"></i>
                            </span>
                            <span class="text">{{language.titlebox5}}</span>
                        </h2>
                        <p class="intro" style="font-size: 23px; padding-bottom: 30px;">{{language.detailbox5}}</p>
                    </header>
                    <ul class="list list-circle">
                        <li class="col-xs-12 col-sm-4">
                            <a [routerLink]="['/fund']" (click)="setFund('risk')">
                                <span rel="border-circle">
                                    <i class="icon icon-bar-chart-search" style="color: white; font-size: 50px;"></i>
                                </span>
                                <span class="text">{{language.menu1box5}}</span>
                            </a>
                        </li>
                        <li class="col-xs-12 col-sm-4">
                            <a [routerLink]="['/fund']" (click)="setFund('recommend')">
                                <span rel="border-circle">
                                    <i class="icon icon-recommend" style="color: white; font-size: 50px;"></i>
                                </span>
                                <span class="text">{{language.menu2box5}}</span>
                            </a>
                        </li>
                        <li class="col-xs-12 col-sm-4">
                            <a [routerLink]="['/fund']" (click)="setFund('risk')">
                                <span rel="border-circle">
                                    <i class="icon icon-diagram" style="color: white; font-size: 50px;"></i>
                                </span>
                                <span class="text">{{language.menu3box5}}</span>
                            </a>
                        </li>
                    </ul>

                    <footer class="footer-button">
                        <a [routerLink]="['/fund']" class="btn btn-primary -brand"
                            (click)="setFund('filter')">{{language.btnbox5}}</a>
                    </footer>
                </section>
            </div>
        </div>
    </div>
</section>


<!--  IMAGE NOT LOAD -->
<section class="section section--data curve -white -top" style="padding-top: 40px;">
    <div class="container">
        <div class="row">

            <div class="col-12 col-xs-12 col-lg-12 col-xl-4" rel="group-row">
                <article class="block-item">
                    <header class="pb-lg-3">
                        <h2 class="topic-title -arrow">
                            <span rel="border-circle" style="font-size: 20px;">
                                <i class="far fa-newspaper" style="color:white;"></i>
                            </span>
                            <span class="text middle">
                                <a *ngIf="flag == 'th'" [routerLink]="['/th', 'News']">{{language.menu1box6}}</a>
                                <a *ngIf="flag == 'en'" style="font-size: 25px;"
                                    [routerLink]="['/th', 'News']">{{language.menu1box6}}</a>
                            </span>
                        </h2>
                    </header>

                    <div *ngIf="flag == 'th'; else elsenews">
                        <div class="row">
                            <div *ngFor="let item of news" class="col-ss-12 col-xs-4 col-md-4 col-lg-4 col-xl-12"
                                rel="group-item">
                                <section class="card -new">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/News/detail',item.newsid]" class="parent">
                                            <span *ngIf="item.news_img_Thum == ''" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                            <span *ngIf="item.news_img_Thum != ''" class="img-photo"
                                                [style.background-image]="getBackground(item.news_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot">
                                            <a [routerLink]="['/th/News/detail',item.newsid]">
                                                {{item.tItle}}
                                            </a>
                                        </h3>
                                        <time>
                                            {{date_thai(item.publicDate)}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elsenews>
                        <div class="row">
                            <div *ngFor="let item of news" class="col-ss-12 col-xs-4 col-md-4 col-lg-4 col-xl-12"
                                rel="group-item">
                                <section class="card -new">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/News/detail',item.newsid]" class="parent">
                                            <span *ngIf="item.news_img_Thum_en == ''" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                            <span *ngIf="item.news_img_Thum_en != ''" class="img-photo"
                                                [style.background-image]="getBackground(item.news_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot">
                                            <a [routerLink]="['/th/News/detail',item.newsid]">
                                                {{item.tItle_en}}
                                            </a>
                                        </h3>
                                        <time>
                                            {{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </ng-template>
                </article>
            </div>

            <div class="col-12 xol-xs-12 col-lg-12 col-xl-4" rel="group-row">
                <article class="block-item">
                    <header class="pb-lg-3">
                        <h2 class="topic-title -arrow">
                            <span rel="border-circle" style="font-size: 20px;">
                                <i class="fas fa-gift" style="color:white;"></i>
                            </span>
                            <span class="text text-bottom">
                                <a *ngIf="flag == 'th'"
                                    [routerLink]="['/FundRecommend','option4']">{{language.menu2box6}}</a>
                                <a *ngIf="flag == 'en'" style="font-size: 25px;"
                                    [routerLink]="['/FundRecommend','option4']">{{language.menu2box6}}</a>
                            </span>
                        </h2>
                    </header>

                    <div class="row">
                        <div class="col-ss-12 col-xs-12 col-md-4 col-lg-4 col-xl-12" rel="group-item"
                            *ngFor="let item of fundrecomm">
                            <div *ngIf="flag == 'th'; else elsefundrecomm">
                                <section class="card -new">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]" class="parent">
                                            <span *ngIf="item.fundRecom_img_Thum == ''" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-2.png')"></span>
                                            <span *ngIf="item.fundRecom_img_Thum != ''" class="img-photo"
                                                [style.background-image]="getBackground(item.fundRecom_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot">
                                            <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]"> {{item.title}}
                                            </a>
                                        </h3>
                                        <time>
                                            {{changeFormatDate(item.publicDate)}} </time>
                                    </div>
                                </section>
                            </div>
                            <ng-template #elsefundrecomm>
                                <section class="card -new">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]" class="parent">
                                            <span *ngIf="item.fundRecom_img_Thum_en == ''" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-2.png')"></span>
                                            <span *ngIf="item.fundRecom_img_Thum_en != ''" class="img-photo"
                                                [style.background-image]="getBackground(item.fundRecom_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot">
                                            <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]">
                                                {{item.title_en}}
                                            </a>
                                        </h3>
                                        <time>
                                            {{item.publicDate | date:'dd MMMM yyyy'}} </time>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </article>
            </div>

            <div class="col-12 col-xs-12 col-lg-12 col-xl-4" rel="group-row">
                <article class="block-item -announcement">
                    <header class="pb-lg-3">
                        <h2 class="topic-title -arrow">
                            <span rel="border-circle" style="font-size: 20px;">
                                <i class="fas fa-bullhorn f-1" style="color:white;"></i>
                            </span>
                            <span class="text middle">
                                <a *ngIf="flag == 'th'"
                                    [routerLink]="['/th', 'Announcement']">{{language.menu3box6}}</a>
                                <a *ngIf="flag == 'en'" style="font-size: 25px;"
                                    [routerLink]="['/th', 'Announcement']">{{language.menu3box6}}</a>
                            </span>
                        </h2>
                    </header>

                    <div class="row">
                        <div class="col-ss-12 col-xs-12 col-md-4 col-lg-4 col-xl-12" rel="group-item"
                            *ngFor="let item of announces, index as i">
                            <div *ngIf="flag == 'th'; else elseannounces">
                                <section class="card -new -small-thumb">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/Announce/detail',item.announceid]"
                                            class="parent hidden-touch">
                                            <span *ngIf="i == 0" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-6.png')"></span>
                                            <span *ngIf="i == 1" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-7.jpg')"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 class="h6 topic-title insert-dotdotdot">
                                            <a class="hidden-touch"
                                                [routerLink]="['/th/Announce/detail',item.announceid]">
                                                {{item.title}}
                                            </a>
                                        </h3>
                                        <time>
                                            {{date_thai(item.publicDate)}}</time>
                                    </div>
                                </section>
                            </div>
                            <ng-template #elseannounces>
                                <section class="card -new -small-thumb">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/Announce/detail',item.announceid]"
                                            class="parent hidden-touch">
                                            <span *ngIf="i == 0" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-6.png')"></span>
                                            <span *ngIf="i == 1" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-7.jpg')"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 class="h6 topic-title insert-dotdotdot">
                                            <a class="hidden-touch"
                                                [routerLink]="['/th/Announce/detail',item.announceid]">
                                                {{item.title_en}}
                                            </a>
                                        </h3>
                                        <time>
                                            {{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>

                            </ng-template>
                        </div>
                    </div>
                </article>

                <article class="block-item">
                    <header class="pb-lg-3">
                        <h2 class="topic-title -arrow">
                            <span rel="border-circle" style="font-size: 20px;">
                                <i class="fas fa-bullhorn f-1" style="color:white;"></i>
                            </span>
                            <span class="text text-bottom">
                                <a *ngIf="flag == 'th'" [routerLink]="['/Promotion','promo']">{{language.menu4box6}}</a>
                                <a *ngIf="flag == 'en'" style="font-size: 25px;"
                                    [routerLink]="['/Promotion','promo']">{{language.menu4box6}}</a>
                            </span>
                        </h2>
                    </header>
                    <div *ngIf="flag == 'th'; else elseEn">
                        <div class="row">
                            <div *ngFor="let item of promotion" class="col-ss-12 col-xs-12 col-md-4 col-lg-4 col-xl-12">
                                <section class="card -new">
                                    <div class="thumb view">
                                        <a *ngIf="item.chanel == 'promo' "
                                            [routerLink]="['/th/Promotion/detail',item.promotionid]" class="parent">
                                            <span *ngIf="item.promotion_img_Thum == ''" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-4.png')"></span>
                                            <span *ngIf="item.promotion_img_Thum != ''" class="img-photo"
                                                [style.background-image]="getBackground(item.promotion_img_Thum)"></span>
                                        </a>

                                        <a *ngIf="item.chanel != 'promo' "
                                            [routerLink]="['/th/Benefit/detail',item.promotionid]" class="parent">
                                            <span *ngIf="item.promotion_img_Thum == ''" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-4.png')"></span>
                                            <span *ngIf="item.promotion_img_Thum != ''" class="img-photo"
                                                [style.background-image]="getBackground(item.promotion_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h5 topic-title insert-dotdotdot">
                                            <a *ngIf="item.chanel == 'promo' "
                                                [routerLink]="['/th/Promotion/detail',item.promotionid]">
                                                {{item.title}}
                                            </a>
                                            <a *ngIf="item.chanel != 'promo' "
                                                [routerLink]="['/th/Benefit/detail',item.promotionid]">
                                                {{item.title}}
                                            </a>
                                        </h3>
                                        <time>{{date_thai(item.publicDate)}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elseEn>
                        <div class="row">
                            <div *ngFor="let item of promotion" class="col-ss-12 col-xs-12 col-md-4 col-lg-4 col-xl-12">
                                <section class="card -new">
                                    <div class="thumb view">
                                        <a *ngIf="item.chanel == 'promo' "
                                            [routerLink]="['/th/Promotion/detail',item.promotionid]" class="parent">
                                            <span *ngIf="item.promotion_img_Thum_en == ''" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-4.png')"></span>
                                            <span *ngIf="item.promotion_img_Thum_en != ''" class="img-photo"
                                                [style.background-image]="getBackground(item.promotion_img_Thum_en)"></span>
                                        </a>

                                        <a *ngIf="item.chanel != 'promo' "
                                            [routerLink]="['/th/Benefit/detail',item.promotionid]" class="parent">
                                            <span *ngIf="item.promotion_img_Thum_en == ''" class="img-photo"
                                                style="background-image: url('../../../assets/images/thumb/photo-4.png')"></span>
                                            <span *ngIf="item.promotion_img_Thum_en != ''" class="img-photo"
                                                [style.background-image]="getBackground(item.promotion_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h5 topic-title insert-dotdotdot">
                                            <a *ngIf="item.chanel == 'promo' "
                                                [routerLink]="['/th/Promotion/detail',item.promotionid]">
                                                {{item.title_en}}
                                            </a>
                                            <a *ngIf="item.chanel != 'promo' "
                                                [routerLink]="['/th/Benefit/detail',item.promotionid]">
                                                {{item.title_en}}
                                            </a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </ng-template>
                </article>

                <article class="block-item">
                    <header class="pb-lg-2">
                        <h2 class="topic-title -arrow">
                            <span rel="border-circle" style="font-size: 20px;">
                                <i class="far fa-list-alt" style="color:white;"></i>
                            </span>
                            <span class="text middle">
                                <a *ngIf="flag == 'th'" [routerLink]="['/th', 'EarthUpdate']">{{language.menu5box6}}</a>
                                <a *ngIf="flag == 'en'" style="font-size: 25px;"
                                    [routerLink]="['/th', 'EarthUpdate']">{{language.menu5box6}}</a>
                            </span>
                        </h2>
                    </header>
                    <div class="row">
                        <div class="col-ss-12 col-xs-4 col-md-4 col-lg-4 col-xl-12" rel="group-item"
                            *ngFor="let item of eartupdate" style="margin-top: 10px">
                            <div *ngIf="flag == 'th'; else elseeartupdate">
                                <section class="card -new -small-thumb">
                                    <div class="info" style="width: 100%;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot">
                                            <a
                                                [routerLink]="['/th/EartUpdate/detail',item.earthupdateid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{date_thai(item.publicDate)}}</time>
                                    </div>
                                </section>
                            </div>
                            <ng-template #elseeartupdate>
                                <section class="card -new -small-thumb">
                                    <div class="info" style="width: 100%;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot">
                                            <a
                                                [routerLink]="['/th/EartUpdate/detail',item.earthupdateid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</section>
<ngx-ui-loader></ngx-ui-loader>

<!-- perModal -->
<div class="modal fade" id="perModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-card--container">
                <button type="button" class="close--button close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        <i class="icon-close"></i>
                    </span>
                </button>
                <h4 class="modal-title" id="calModalLabel">
                    <div class="border-circle">
                        <img src="assets/images/icon/ic-barchart-blue@2x.png" alt="icon" />
                    </div>
                    <span class="text">Performance Report</span>
                </h4>
                <div class="modal--body">
                    <table class="table table--fund -credit table-striped table-hover">
                        <thead>
                            <tr>
                                <th width="10%">NO.</th>
                                <th width="50%" class="text-left">Portfolio</th>
                                <th width="40%">{{investPeriod}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1.</td>
                                <td class="text-left">{{investPortfolioCode}}</td>
                                <td>{{investBenchmark}}%</td>
                            </tr>
                            <tr>
                                <td>2.</td>
                                <td class="text-left">{{investSd}}</td>
                                <td>{{investSDBenchmark}}%</td>
                            </tr>
                            <tr *ngFor="let dpr of dataPerformanceReports">
                                <td>{{dpr['index']}}.</td>
                                <td class="text-left">{{dpr['value']}}</td>
                                <td>{{dpr['percent']}}%</td>
                            </tr>
                        </tbody>
                    </table>
                    <section class="footer-remark">
                        <header>
                            <h5 class="topic-title">Note</h5>
                        </header>

                        <div class="info">
                            <p *ngFor="let item of investNoteTitle">{{item['index']}}.
                                <span>{{item['noteTitle']}}</span>
                                <br> {{item['noteDetail']}}
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- sumModal -->
<div class="modal fade" id="sumModal" tabindex="-1" role="dialog" aria-labelledby="perforModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-card--container">
                <button type="button" class="close--button close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        <i class="icon-close"></i>
                    </span>
                </button>
                <h4 class="modal-title" id="calModalLabel">
                    <div class="border-circle">
                        <img src="assets/images/icon/ic-cal-blue@2x.png" alt="icon" />
                    </div>
                    <span class="text">Performance Calculation</span>
                </h4>
                <div class="modal--body">
                    <section class="wrapper-modal">
                        <!-- table 1 -->
                        <section class="group-table">
                            <table class="table table--fund -credit table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th>NO.</th>
                                        <th class="text-left">Portfolio</th>
                                        <th>YTD</th>
                                        <th>3M</th>
                                        <th>6M</th>
                                        <th>1Y</th>
                                        <th>3Y</th>
                                        <th>5Y</th>
                                        <th>10Y</th>
                                        <th>Since
                                            <br> Inception
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td class="text-left">{{portPerformance[0]}}</td>
                                        <td>{{portPerformance[1]}}%</td>
                                        <td>{{portPerformance[2]}}%</td>
                                        <td>{{portPerformance[3]}}%</td>
                                        <td>{{portPerformance[4]}}%</td>
                                        <td>{{portPerformance[5]}}%</td>
                                        <td>{{portPerformance[6]}}%</td>
                                        <td>{{portPerformance[7]}}%</td>
                                        <td>{{portPerformance[8]}}%</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td class="text-left">{{portSDPerformance[0]}}</td>
                                        <td>{{portSDPerformance[1]}}%</td>
                                        <td>{{portSDPerformance[2]}}%</td>
                                        <td>{{portSDPerformance[3]}}%</td>
                                        <td>{{portSDPerformance[4]}}%</td>
                                        <td>{{portSDPerformance[5]}}%</td>
                                        <td>{{portSDPerformance[6]}}%</td>
                                        <td>{{portSDPerformance[7]}}%</td>
                                        <td>{{portSDPerformance[8]}}%</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td class="text-left">{{portBenchmarkPerformance[0]}}</td>
                                        <td>{{portBenchmarkPerformance[1]}}%</td>
                                        <td>{{portBenchmarkPerformance[2]}}%</td>
                                        <td>{{portBenchmarkPerformance[3]}}%</td>
                                        <td>{{portBenchmarkPerformance[4]}}%</td>
                                        <td>{{portBenchmarkPerformance[5]}}%</td>
                                        <td>{{portBenchmarkPerformance[6]}}%</td>
                                        <td>{{portBenchmarkPerformance[7]}}%</td>
                                        <td>{{portBenchmarkPerformance[8]}}%</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td class="text-left">{{portSDBenchmarkPerformance[0]}}</td>
                                        <td>{{portSDBenchmarkPerformance[1]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[2]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[3]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[4]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[5]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[6]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[7]}}%</td>
                                        <td>{{portSDBenchmarkPerformance[8]}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                            <section class="footer-remark">
                                <header>
                                    <h5 class="topic-title">Note</h5>
                                </header>

                                <div class="info">
                                    <p *ngFor="let item of portPerfNote">{{item['index']}}. {{item['noteTitle']}}
                                        <br> {{item['noteDetail']}}
                                    </p>
                                </div>
                            </section>
                        </section>

                        <!-- table 2 -->
                        <section class="group-table" style="margin-top: 40px;">
                            <table class="table table--fund -credit table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th class="text-left">ปี</th>
                                        <th>{{returnPerfYear[0]}}</th>
                                        <th>{{returnPerfYear[1]}}</th>
                                        <th>{{returnPerfYear[2]}}</th>
                                        <th>{{returnPerfYear[3]}}</th>
                                        <th>{{returnPerfYear[4]}}</th>
                                        <th>{{returnPerfYear[5]}}</th>
                                        <th>{{returnPerfYear[6]}}</th>
                                        <th>{{returnPerfYear[7]}}</th>
                                        <th>{{returnPerfYear[8]}}</th>
                                        <th>{{returnPerfYear[9]}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left">{{returnPortPerf[0]}}</td>
                                        <td>{{returnPortPerf[1]}}%</td>
                                        <td>{{returnPortPerf[2]}}%</td>
                                        <td>{{returnPortPerf[3]}}%</td>
                                        <td>{{returnPortPerf[4]}}%</td>
                                        <td>{{returnPortPerf[5]}}%</td>
                                        <td>{{returnPortPerf[6]}}%</td>
                                        <td>{{returnPortPerf[7]}}%</td>
                                        <td>{{returnPortPerf[8]}}%</td>
                                        <td>{{returnPortPerf[9]}}%</td>
                                        <td>{{returnPortPerf[10]}}%</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">{{returnPortSDPerf[0]}}</td>
                                        <td>{{returnPortSDPerf[1]}}%</td>
                                        <td>{{returnPortSDPerf[2]}}%</td>
                                        <td>{{returnPortSDPerf[3]}}%</td>
                                        <td>{{returnPortSDPerf[4]}}%</td>
                                        <td>{{returnPortSDPerf[5]}}%</td>
                                        <td>{{returnPortSDPerf[6]}}%</td>
                                        <td>{{returnPortSDPerf[7]}}%</td>
                                        <td>{{returnPortSDPerf[8]}}%</td>
                                        <td>{{returnPortSDPerf[9]}}%</td>
                                        <td>{{returnPortSDPerf[10]}}%</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">{{returnPortBenchmark[0]}}</td>
                                        <td>{{returnPortBenchmark[1]}}%</td>
                                        <td>{{returnPortBenchmark[2]}}%</td>
                                        <td>{{returnPortBenchmark[3]}}%</td>
                                        <td>{{returnPortBenchmark[4]}}%</td>
                                        <td>{{returnPortBenchmark[5]}}%</td>
                                        <td>{{returnPortBenchmark[6]}}%</td>
                                        <td>{{returnPortBenchmark[7]}}%</td>
                                        <td>{{returnPortBenchmark[8]}}%</td>
                                        <td>{{returnPortBenchmark[9]}}%</td>
                                        <td>{{returnPortBenchmark[10]}}%</td>
                                    </tr>
                                    <tr>
                                        <td class="text-left">{{returnPortSDBenchmark[0]}}</td>
                                        <td>{{returnPortSDBenchmark[1]}}%</td>
                                        <td>{{returnPortSDBenchmark[2]}}%</td>
                                        <td>{{returnPortSDBenchmark[3]}}%</td>
                                        <td>{{returnPortSDBenchmark[4]}}%</td>
                                        <td>{{returnPortSDBenchmark[5]}}%</td>
                                        <td>{{returnPortSDBenchmark[6]}}%</td>
                                        <td>{{returnPortSDBenchmark[7]}}%</td>
                                        <td>{{returnPortSDBenchmark[8]}}%</td>
                                        <td>{{returnPortSDBenchmark[9]}}%</td>
                                        <td>{{returnPortSDBenchmark[10]}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                            <section class="footer-remark">
                                <header>
                                    <h5 class="topic-title">{{language.disclaimer1}}</h5>
                                </header>
                                <div class="info">
                                    <ol class="list-number">
                                        <li>{{language.disclaimer2}}
                                        </li>
                                        <li>{{language.disclaimer3}}
                                        </li>
                                        <li>
                                            <span class="text-danger">{{language.disclaimer4}}</span>
                                        </li>
                                        <li>{{language.disclaimer5}}</li>
                                        <li>{{language.disclaimer6}}</li>
                                        <li>{{language.disclaimer7}}
                                        </li>
                                        <li>{{language.disclaimer8}}
                                        </li>
                                    </ol>
                                </div>
                            </section>
                        </section>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div id="warningModalFormanceSum_Main" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="false">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header -nobg">
                <div class="float-left">
                    <h4 class="modal-title"><span class="text">คำเตือน</span></h4>
                </div>
                <div class="float-right">
                    <button type="button" id="closeNotice" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="userclosesummain()">
                        <span aria-hidden="true"><i class="icon-close custom-color-icon"></i></span>
                    </button>
                </div>
            </div>
            <section class="wrapper-notice">
                <div class="modal-body" tabindex="4" style="line-height: 1.6; text-align: center;overflow: hidden;">
                    <h4>ไม่พบข้อมูล</h4>
                </div>
            </section>
            <div class="modal-footer" style="margin: 0 auto">
                <app-button text="{{language.ed_pop_up}}" size="lg" (click)="userclosesummain()"></app-button>
            </div>
        </div>
    </div>
</div> -->